import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Banknote, ArrowRightLeft, ReceiptText, User, Users, MessageCircle, Menu } from './icons';
import api from '../api';
import useAdminNavigation from '../utils/useAdminNavigation';
import './Navigation.css';

const items = [
  { to: '/', label: 'خانه', icon: Home, paths: ['/'] },
  { to: '/deposit-withdraw_page', label: 'کیف پول', icon: Banknote, paths: ['/deposit-withdraw_page', '/wallet-requests_page', '/bank-accounts_page'] },
  { to: '/trade_page', label: 'معامله', icon: ArrowRightLeft, paths: ['/trade_page', '/gold-request_page'] },
  { to: '/transactions_page', label: 'تراکنش‌ها', icon: ReceiptText, paths: ['/transactions_page'] },
  { to: '/profile_page', label: 'پروفایل', icon: User, paths: ['/profile_page', '/edit-profile_page', '/security_page', '/referral_page'] },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  const token = localStorage.getItem('authToken');
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    let active = true;
    setIsAdmin(false);
    if (token) api.get('/api/users/me', { timeout: 10000 }).then(response => {
      if (active) setIsAdmin(Number(response.data.user?.is_admin) === 1);
    }).catch(() => {});
    return () => { active = false; };
  }, [token]);
  const counts = useAdminNavigation(isAdmin, pathname);
  const adminItems = [
    { to: '/', label: 'خانه', icon: Home, paths: ['/'] },
    { to: '/AdminWalletRequests_page', label: 'درخواست‌ها', icon: Banknote, paths: ['/adminwalletrequests_page', '/admin-gold-requests_page'], count: (counts.wallet || 0) + (counts.gold || 0) },
    { to: '/admin-crm_page', label: 'CRM', icon: Users, paths: ['/admin-crm_page'], count: counts.overdue },
    { to: '/admin-chat_page', label: 'چت', icon: MessageCircle, paths: ['/admin-chat_page'], count: counts.chat },
    { to: '/AdminPanel_page', label: 'بیشتر', icon: Menu, paths: ['/adminpanel_page', '/admin-grades_page', '/admin-activity_page', '/adminuserbalances_page', '/admingoldtransactions_page', '/adminchargeaccount_page', '/adminpricesettings_page'] },
  ];
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  useEffect(() => {
    if (!/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) return undefined;
    const viewport = window.visualViewport;
    let baseline = viewport?.height || window.innerHeight;
    const resize = () => {
      const height = viewport?.height || window.innerHeight;
      const editing = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || '');
      if (!editing) baseline = Math.max(baseline, height);
      setKeyboardOpen(editing && baseline - height > 120);
    };
    const rotate = () => { baseline = viewport?.height || window.innerHeight; setKeyboardOpen(false); };
    window.addEventListener('resize', resize); window.addEventListener('orientationchange', rotate);
    document.addEventListener('focusin', resize); document.addEventListener('focusout', resize); viewport?.addEventListener('resize', resize);
    return () => { window.removeEventListener('resize', resize); window.removeEventListener('orientationchange', rotate); document.removeEventListener('focusin', resize); document.removeEventListener('focusout', resize); viewport?.removeEventListener('resize', resize); };
  }, []);
  if (keyboardOpen || /^\/(admin-)?chat_page\/?$/i.test(pathname)) return null;
  const path = pathname.toLowerCase().replace(/\/$/, '') || '/';
  return <div className="site-bottom-shell" dir="rtl"><nav className="site-bottom-nav" aria-label={isAdmin ? 'ناوبری مدیریت پایین' : 'ناوبری اصلی پایین'}>{(isAdmin ? adminItems : items).map(item => {
    const active = item.paths.includes(path);
    return <Link key={item.to} to={item.to} aria-current={active ? 'page' : undefined} className={`site-bottom-link${active ? ' is-active' : ''}${item.to === '/trade_page' ? ' site-bottom-link--trade' : ''}`}><span className="site-bottom-icon"><item.icon size={21} /></span><span>{item.label}</span>{item.count > 0 && <b className="site-unread site-bottom-badge" aria-label={`${item.count} مورد نیازمند رسیدگی`}>{item.count > 99 ? '۹۹+' : item.count.toLocaleString('fa-IR')}</b>}<i aria-hidden="true" /></Link>;
  })}</nav></div>;
}
